import CashFlowTablesEnum from '@/views/cashFlowGroupers/mainGrouper/enums/CashFlowTablesEnum';
import MainGroupersScreensShownEnum from '@/views/cashFlowGroupers/mainGrouper/enums/MainGroupersScreensShownEnum';

export default class MainGrouperList {
  constructor(
    public id: number,
    public name: string,
    public status: boolean,
    public table: CashFlowTablesEnum,
    public screensToShown: MainGroupersScreensShownEnum[],
  ) { }

  static make(data: any): MainGrouperList {
    return new MainGrouperList(
      data.id,
      data.name,
      data.status,
      data.selected_table,
      data.screens_to_shown,
    );
  }
}
